import { useCallback, useEffect, useState } from "react";
import { callApi } from "../utils/apiClient";
import { API_ENDPOINTS } from "../config/api/apiCall";
import { loadShiftAssignedEmployeesList, loadShiftEmployeeAssignment } from "../services/shiftService";
const useShiftEmployeeAssignment = () => {
    const [loading, setLoading] = useState(false);
    const [message, setMessage] = useState(null);
    const [error, setError] = useState(null);
    const [shiftEmployeeAssignmentlist, setShiftEmployeeAssignmentlist] = useState([]);
    const [SelectedshiftEmployeeAssignmentlist, setSelectedshiftEmployeeAssignmentlist] = useState([]);
    // 🔹 INSERT New Shift Employee Assignment
    const insertShiftAssignment = useCallback(async (shiftAssignmentData) => {
        setLoading(true);
        setError(null);
        try {
            const response = await callApi(API_ENDPOINTS.HR_SHIFT_EMPLOYEE_ASSIGNMENT_ROASTER_ADD, "POST",
                { "Content-Type": "application/json" },
                shiftAssignmentData
            );

            if (response[0].assignment_id !== 0) {
                return { success: true, data: response };
            } else {
                throw new Error(response.message || "Insert failed.");
            }
        }
        catch (err) {
            setError(err.message);
            return { success: false, error: err.message };
        }
        finally {
            setLoading(false);
        }
    }, []);


    // 🔹 UPDATE Existing Shift Employee Assignment
    const updateShiftAssignment = useCallback(async (updatedData) => {
        setLoading(true);
        setError(null);
        try {
            const response = await callApi(API_ENDPOINTS.HR_SHIFT_EMPLOYEE_ASSIGNMENT_ROASTER_ADD, "POST",
                { "Content-Type": "application/json" },
                updatedData
            );

            if (response[0].assignment_id !== 0) {
                return { success: true, data: response };
            } else {
                throw new Error(response.message || "Update failed.");
            }
        } catch (err) {
            setError(err.message);
            return { success: false, error: err.message };
        } finally {
            setLoading(false);
        }
    }, []);

    const SelectedShiftEmployeeAssignmentDetails = async (parameter) => {
        try {
            const data = await loadShiftAssignedEmployeesList(parameter);
            if (data && data.length > 0) {
                setSelectedshiftEmployeeAssignmentlist(data);
            }
            else {
                setSelectedshiftEmployeeAssignmentlist([]);
            }
        } catch (err) {
            setError(err.message);
            return { success: false, error: err.message };
        } finally {
            setLoading(false);
        }
    };


    // // 🔹 Selected Assignment Id Shift Employee Assignment details
    // const SelectedShiftEmployeeAssignmentDetails= useCallback(async (parameter) => {
    //     setLoading(true);
    //     setError(null);
    //     try {
    //         const data = await loadShiftAssignedEmployeesList(parameter);
    //         if (data && data.length > 0) {
    //             setSelectedshiftEmployeeAssignmentlist(data);
    //         }
    //         else {
    //             setSelectedshiftEmployeeAssignmentlist([]);
    //         }
    //     } catch (err) {
    //         setError(err.message);
    //         return { success: false, error: err.message };
    //     } finally {
    //         setLoading(false);
    //     }
    // }, []);

    // 🔹 Load Shift Employee Assignment List
    useEffect(() => {
        fetchShiftEmployeeAssigmentList();
    }, []);

    const fetchShiftEmployeeAssigmentList = async (selectedID = null) => {
        const para = {
            p_companyid: localStorage.getItem("companyid"),
        };

        try {
            const data = await loadShiftEmployeeAssignment(para);
            if (data && data.length > 0) {
                setShiftEmployeeAssignmentlist(data);
            }
        } catch (error) {
            setError(error.message);
        }
    };

    return { insertShiftAssignment, updateShiftAssignment, shiftEmployeeAssignmentlist, SelectedShiftEmployeeAssignmentDetails, SelectedshiftEmployeeAssignmentlist, loading, error };


}
export default useShiftEmployeeAssignment;